import Container from "@/components/common/Container";
import PrimaryButton from "@/components/common/PrimaryButton";
import { LINK_OF_ALL_PAGES } from "const/common";

const ServiceCard = (data) => {
  const { title } = data.webAppCard;
  return (
    <Container large className="bg-primary-black pb-36 md:pb-20 xl:pb-40">
      <div className="md:flex justify-between items-center rounded-lg xl:rounded-2xl py-14 px-4 md:py-12 md:px-16 xl:p-20 bg-[#251d1e]">
        <div className="lg:w-3/5 xl:w-4/5">
          <h3 className="font-normal text-white text-2xl md:text-xl xl:text-4xl mb-10 md:mb-0 leading-normal xl:leading-snug text-center md:text-start">
            <span>{title}</span>
          </h3>
        </div>
        <div className="flex justify-center md:justify-end w-full md:w-1/2 xl:w-full">
          <div className="mx-auto md:me-0 md:ms-auto">
            <PrimaryButton
              className="min-w-fit py-3 px-8 rounded-lg md:rounded lg:rounded-lg md:py-2 md:px-4 xl:py-4 xl:px-10"
              link={LINK_OF_ALL_PAGES.mainPages.contactUs}
              val="Contact Now"
            />
          </div>
        </div>
      </div>
    </Container>
  );
};
export default ServiceCard;
